import { BodyText, Flex, Strong } from '@utilitywarehouse/hearth-react';
import { TickSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import { ReactNode } from 'react';

import { BroadbandSpeed } from '@generated/gql/graphql';
import { BroadbandQuote } from '@src/types/broadband';

import './styles.scss';

interface BroadbandBreakdownProps {
  product: BroadbandQuote['product'];
}

const BreakdownListItem = ({ children }: { children: ReactNode }) => (
  <Flex asChild spacing="sm">
    <li>
      <TickSmallIcon /> {children}
    </li>
  </Flex>
);

const BroadbandBreakdown = ({ product }: BroadbandBreakdownProps) => {
  const speeds = product.details.speeds?.[0] as BroadbandSpeed;

  const renderDownloadSpeed = () => {
    if (speeds.downstreamMin && speeds.guaranteedDownstream) {
      return (
        <>
          <BreakdownListItem>
            <BodyText as="span">
              <Strong>
                {speeds.downstreamMin}&ndash;{speeds.downstreamMax}
              </Strong>{' '}
              Mbps estimated download speed
            </BodyText>
          </BreakdownListItem>

          <BreakdownListItem>
            <BodyText as="span">
              <Strong>{speeds.guaranteedDownstream}</Strong> Mbps minimum
              download speed
            </BodyText>
          </BreakdownListItem>
        </>
      );
    }

    return (
      <BreakdownListItem>
        <BodyText as="span">
          <Strong>{speeds.downstreamMax}</Strong> Mbps maximum download speed
        </BodyText>
      </BreakdownListItem>
    );
  };

  const renderUploadSpeed = () => {
    if (speeds.upstreamMin) {
      return (
        <BreakdownListItem>
          <BodyText as="span">
            <Strong>
              {speeds.upstreamMin}&ndash;{speeds.upstreamMax}
            </Strong>{' '}
            Mbps estimated upload speed
          </BodyText>
        </BreakdownListItem>
      );
    }

    return (
      <BreakdownListItem>
        <BodyText as="span">
          <Strong>{speeds.upstreamMax}</Strong> Mbps maximum upload speed
        </BodyText>
      </BreakdownListItem>
    );
  };

  return (
    <Flex asChild spacing="lg" direction="column">
      <ul className="broadband-breakdown__list">
        {renderDownloadSpeed()}
        {renderUploadSpeed()}
      </ul>
    </Flex>
  );
};

export { BroadbandBreakdown };
